// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__iUvtV","footer":"ChangeClinic_footer__16Zuk"};